import { alpha } from '@mui/material'
import { colors } from './colors.theme'

const filledColors = Object.fromEntries(
  Object.entries(colors).map(([key, val]) => {
    return [
      [`&.${key}`],
      {
        color: colors.white,
        backgroundColor: val,
        '& .MuiChip-icon': {
          color: colors.white,
        },
        '& .MuiSvgIcon-root': {
          color: colors.white,
        },
      },
    ]
  }),
)

const outlinedColors = Object.fromEntries(
  Object.entries(colors).map(([key, val]) => {
    return [
      [`&.${key}`],
      {
        borderColor: val,
        color: val,
        backgroundColor: alpha(val, 0.1),
        '& .MuiChip-icon': {
          color: val,
        },
        '& .MuiSvgIcon-root': {
          color: val,
        },
      },
    ]
  }),
)

export const chipTheme = {
  root: { borderRadius: 8 },
  label: {
    fontWeight: 600,
    lineHeight: 1.5,
  },
  filled: {
    color: colors.white,
    backgroundColor: colors.gray,
    '& .MuiChip-icon': {
      color: colors.white,
    },
    '& .MuiSvgIcon-root': {
      color: colors.white,
    },
    ...filledColors,
  },
  outlined: {
    borderColor: colors.white,
    color: colors.white,
    backgroundColor: alpha(colors.gray, 0.1),
    ...outlinedColors,
  },
}
